module.exports = __webpack_public_path__ + "static/media/about.6571f28b.jpg";